(function($) {
    var site = {
        playTimer : false,
        photo_size : '',
        is_home : $('.homepage').length > 0,

        /**
         * Run all the setup scripts, as necessary, on page-load
         */
        init : function() {
            site.external_links();

            site.set_photo_size();
            $(window).on('resize', site.set_photo_size);

            site.photo_nav();

            site.show_hide_thumbs();
        },

        /**
         * Open links with rel="external" in a new tab
         */
        external_links : function() {
            var external = new RegExp('/' + window.location.host + '/');
            $('a').each(function() {
               if (!external.test(this.href))
                    $(this).attr("target", "_blank");
            });
        },

        /**
         * In-place navigation of the photo galleries
         */
        photo_nav : function() {
            if (typeof window.gallery_photos === 'undefined') return;

            var img_el = document.getElementById('main-img');

            if (img_el) {
                var mc = new Hammer(img_el);

                mc.on("swipeleft", function(event) {
                    event.preventDefault();
                    $('a.next').first().trigger('click');
                });

                mc.on("swiperight", function(event) {
                    event.preventDefault();
                    $('a.prev').trigger('click');
                });
            }

            $('body').on('keyup', function(event) {
                switch (event.keyCode) {
                    case 39: $('a.next').first().trigger('click'); break;
                    case 37: $('a.prev').trigger('click');
                }
            });

            // Hide the description if not needed
            if ($('body').hasClass('gallery')) {
                var current_url = String(window.location.href);
                site.switch_photo(current_url, 0);
            } else if (img_el) {
                var photo = window.gallery_photos[0];
            }

            $('a[data-nav]').on('click', function() {
                var new_url = site.switch_photo(this.href);

                // Stop the slideshow
                if (site.playTimer) $('a.pause').click();

                return false;
            });

            $('#controls')
                // "Play" button
                .on('click', 'a.play', function() {
                    $(this).toggleClass('play pause');

                    site.playTimer = setInterval(function() {
                        site.switch_photo($('a.next').get(0).href);
                    }, 6000);

                    return false;
                })
                // "Pause" button
                .on('click', 'a.pause', function() {
                    $(this).toggleClass('play pause');
                    clearInterval(site.playTimer);
                    return false;
                });

            // Always start the slideshow on the homepage
            if (site.is_home && window.gallery_photos.length > 1) {
                site.playTimer = setInterval(function() {
                    site.switch_photo($('a.next').get(0).href);
                }, 6000);
            }
        },

        /**
         * Move from one photo to the next
         */
        switch_photo : function(url, delay) {
            if (window.gallery_photos === 'undefined') return;

            var $wrapper = $('#image-wrapper'),
                $mainImg = $('#main-img'),
                $img = $mainImg.find('.img'),
                has_gallery_desc = /\S/.test($('.gallery-desc').text()),
                index = parseInt(url.replace(/^.+\//, ''), 10) - 1 || 0,
                base_url = url.replace(/\/(\d+)$/, '/'),
                photo = window.gallery_photos[index];

            delay = delay || 150;

            // Update the photo and caption
            $img.css('opacity', 0);
            setTimeout(function() { // Timeout to account for CSS transition
                // Update the content
                if (photo) $mainImg.find('figcaption').html(photo.caption);
                $('.photo-desc').html(photo.desc);

                // Only show the gallery description with the first image
                $('.gallery-desc').toggle(index === 0 && has_gallery_desc);
                $wrapper.toggleClass('has-description', ((index === 0 && has_gallery_desc) || photo.desc !== ''));

                // Show the new photo
                site.set_photo_size();
                var $newImg = $('<img src="'+photo[site.photo_size]+'" alt="'+photo.alt_text+'"><img src="'+photo.xlg+'" class="photo-magnified">')
                    .on('load', site.set_photo_size);
                $img.html($newImg);
                $img.css('opacity', 1);
            }, delay);

            // Reset the navigation links
            var next_index = (index + 1 < window.gallery_photos.length) ? index + 2 : 1,
                prev_index = index > 0 ? index : window.gallery_photos.length;
            $('a.next').attr('href', base_url + next_index);
            $('a.prev').attr('href', base_url + prev_index);

            // Update the URL bar
            if (!site.is_home && window.gallery_photos.length > 1) {
                var new_url = base_url + (index + 1);
                if (history.pushState) {
                    window.history.replaceState(null, null, new_url);
                }
            }
        },

        /**
         * Preload the images
         */
        preload_photos : function() {
            if ($('#preloaded_photos').length < 1) {
                $('body').append('<div id="preloaded_photos" style="display:none"/>');
            }

            setTimeout(function() {
                var all_photos = '';
                $.each(window.gallery_photos, function() {
                    all_photos += '<img src="'+this[site.photo_size]+'">';
                });
                $('#preloaded_photos').html(all_photos);
            }, 4000);
        },

        /**
         * Make single photos fit the height of the page
         */
        set_photo_size : function() {
            var $container = $('#main-img');
            if ($container.length === 0) return;

            var $wrapper = $container.find('.img'),
                $img = $container.find('img').first(),
                header_height = $('#pageTop').height(),
                dpi = typeof window.devicePixelRatio !== 'undefined' ? window.devicePixelRatio : 1,
                width_cutoff = 1000 / dpi,
                height_cutoff = 800 / dpi,
                old_size = site.photo_size,
                imgWidth = $img.get(0).naturalWidth,
                imgHeight = $img.get(0).naturalHeight,
                offset;

            $img.on('load', site.set_photo_size);

            // Set main image area height
            if (site.is_home) {
                offset = $(window).width() > 900 ? 100 : 88;
            } else {
                offset = $(window).width() > 900 ? 88 : 22;
            }
            $container.css('height', $(window).height() - header_height - offset);

            // Size and align image
            var containerWidth = $container.width(),
                containerHeight = $container.height();
            if (imgWidth / imgHeight > containerWidth / containerHeight) {
                var height = Math.round(imgHeight / imgWidth * containerWidth);
                var width = containerWidth;
                $wrapper.css({
                    marginTop: (containerHeight - height) / 2,
                    marginLeft: 0
                });
            } else {
                var width = Math.round(imgWidth / imgHeight * containerHeight);
                var height = containerHeight;
                $wrapper.css({
                    marginTop: 0,
                    marginLeft: (containerWidth - width) / 2
                });
            }
            $wrapper.height(height);
            $wrapper.width(width);

            site.photo_size = ($container.width() > width_cutoff || $container.height() > height_cutoff) ? 'lg' : 'med';

            // If the size changed, preload the new ones
            if (old_size !== site.photo_size) site.preload_photos();
        },

        /**
         * Slide the thumbnails into view on hover
         */
        show_hide_thumbs : function() {
            // Make sure there ARE thumbnails
            var $thumbs = $('#thumbs');
            if ($thumbs.length === 0) return;

            // Insert a <style> block to store our rule in
            var $style = $('<style/>').appendTo('head');

            // Update the hidden offset
            function update_offset() {
                var offset = $thumbs.outerHeight() - 44;
                $style.text("#thumbs { bottom: -" + offset + "px }");
            }

            update_offset();

            // Fix the offset when the window size changes
            $(window).resize(update_offset);
        }
    };

    $(document).ready(site.init);
})(jQuery);
